<template>
  <!-- 基础上下布局 -->
  <div class="base-container" :class="{noPageHd: !isPageHd, noMainHd: !isMainHd, noPageFt: !isHasPageFt, }"  v-loading="loading">
    <header class="base-container-hd" v-if="isPageHd"><span class="arrow"></span> {{ getCurMenu }}</header>
    <!-- 上中下布局方式 -->
    <template>
      <main class="base-container-bd">
        <header class='content-hd'><slot name="hd"></slot></header>
        <section class='content-bd'><slot name="main"></slot></section>
      </main>
      <!-- 用于存放分页信息 -->
      <footer class="base-container-ft" v-if="isHasPageFt"><slot name="ft"></slot></footer>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "baseContainer",
  props: {
    isPageHd: {          // 是否含有页面头部
      type: Boolean,
      default: false,
    },
    isMainHd: {          // 是否含有头部区域（一般是表格上面搜索区域）
      type: Boolean,
      default: true,
    },

    isHasPageFt: {           // 是否含有底部区域（一般是表格展示下分页）
      type: Boolean,
      default: false,        
    },

    loading: {              // 页面loading, 非表格页面使用(表格页面自带loading)
      type: Boolean,
      default: false,
    },
  },

  data(){
    return {
      loadingInstance: null
    }
  },

  computed: { 
    ...mapGetters(['userInfo',]),
    getCurMenu() {
      return this.$route.name
    },
  },

  watch: {
    '$route': function() {
    },

  }
 
};
</script>
<style lang="scss" scope>
.base-container {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 14px 20px; 
    padding-bottom: 0;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    .base-container-hd {
      position: relative;
      z-index: 100;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-left: 10px;
      padding-bottom: 12px;
      font-size: 16px;
      line-height: 1.5;
      color: #333;
      border-bottom: 1px solid #EBEBEB;
      .arrow {
        display: inline-block;
        position: relative;
        top: 5px;
        margin-right: 5px;
        width: 4px;
        height: 20px;
        background: #228aff;
      }
    }
    .base-container-bd {
        position: relative;
        width: 100%;
        height: calc(100% - 69px);
        color: #333;
        overflow: auto;
    }

    .base-container-ft {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 15px;
      padding-right: 20px;
      height: 48px;
      background-color: #fff;
      border-radius: 2;
      z-index: 100;
      border-top: 1px solid #ebebeb;
    }

    .avue-crud {
      width: 100%;
    }

    .content-hd {
      position: relative;
      height: 36px;
      line-height: 36px;
      // margin-bottom: 20px;
      padding-bottom: 20px;
      // border-bottom: 1px solid #EBEBEB;
      
      .mybtns {
        float: right;
      }
    }

    .content-bd {
      width: 100%;
      height: calc(100% - 56px);
      // padding: 10px;
      // background-color: #f6f6f6;
      // border-radius: 2px;
      // overflow-y: auto;
    }
    
    // 无标题和底部
    &.noPageHd.noPageFt {
      .base-container-bd {
        height: 100%;
      }

    }
    
    // 无标题
    &.noPageHd {
      .base-container-bd {
        height: calc(100% - 69px);
      }
    }

    // 无底部
    &.noPageFt {
      .base-container-bd {
        height: calc(100% - 68px);
      }
    }
    
    // 无表格上面的搜索区块
    &.noMainHd {
      .base-container-bd {
        height: calc(100% - 36px);
      }

      .content-hd {
        display: none;
      }
      .content-bd {
        padding: 2px 0 2px 10px;
        height: calc(100% - 25px);
      }
    }
}
</style>



// WEBPACK FOOTER //
// BaseContainer.vue?4df58372